import moment from 'moment';
import { createContext } from 'react';
import { MetricsMap } from './metricsUtils';

export const NO_VALUE = 'N/A';
export const NONE_TAG_VALUE = 'None';
export const DATE_RANGE_DATE_FORMAT = 'YYYY-MM-DD';
export const DEFAULT_START_DATE = moment()
    .subtract(6, 'days')
    .format(DATE_RANGE_DATE_FORMAT);
export const DEFAULT_END_DATE = moment().format(DATE_RANGE_DATE_FORMAT);
export const DEFAULT_METRICS = [MetricsMap.CUSTOM_IMPRESSIONS, MetricsMap.CUSTOM_CLICKS, MetricsMap.CUSTOM_INSTALLS];

export const GalleryContext = createContext();

export const TRACK_EVENT_PREFIX = 'Creatives Gallery';
export const CREATIVE_GALLERY_REPORT_TYPE = 'creativeGallery';
export const DEFAULT_AI_FILTERS = ['Keywords'];

export const CardSections = {
    MULTI_VALUED_DIMENSIONS: 'multiValuedDimensions',
    METRICS: 'metrics',
};

export const CREATIVES_TAB = 'CREATIVES';
export const INSIGHTS_TAB = 'INSIGHTS';

export const CreativeTabs = [
    {
        id: CREATIVES_TAB,
        label: 'STATIC.CREATIVE_IQ.CREATIVE_GALLERY.MY_CREATIVES_TAB',
    },
    {
        id: INSIGHTS_TAB,
        label: 'STATIC.CREATIVE_IQ.CREATIVE_GALLERY.INSIGHTS_TAB',
        iconName: 'bulb',
    },
];

export const LayoutConfig = {
    GRID: {
        type: 'grid',
        icon: 'layout-grid',
        tooltip: 'STATIC.TOOLTIPS.GRID_LAYOUT',
    },
    GALLERY: {
        type: 'gallery',
        icon: 'layout-dashboard',
        tooltip: 'STATIC.TOOLTIPS.GALLERY_LAYOUT',
    },
};

export const CreativeFilters = {
    APP: 'App',
    SOURCE: 'Source',
    METRICS: 'Metrics',
    DATE_RANGE: 'Date Range',
    COHORTS: 'Cohorts',
};

export const ANALYSIS_TAB_ID = 'ANALYSIS';
export const CREATIVE_TAGS_TAB_ID = 'CREATIVE_TAGS';

export const CreativeCardTabs = [
    {
        id: CREATIVE_TAGS_TAB_ID,
        label: 'STATIC.PAGES.CREATIVE_GALLERY.CREATIVE_POPUP.CREATIVE_TAGS_TAB',
        iconName: 'tags',
    },
    {
        id: ANALYSIS_TAB_ID,
        label: 'STATIC.PAGES.CREATIVE_GALLERY.CREATIVE_POPUP.ANALYSIS_TAB',
        iconName: 'chart-pie',
    },
];

export const Dimensions = {
    APP: 'app',
    SOURCE: 'source',
    HAS_CREATIVE_PREVIEW: 'has_creative_preview',
    CREATIVE_TYPE: 'creative_type',
    CREATIVE_IMAGE_HASH: 'creative_image_hash',
    CREATIVE_EMBEDDING_URL: 'creative_embedding_url',
    CREATIVE_WIDTH: 'creative_width',
    CREATIVE_HEIGHT: 'creative_height',
    CREATIVE_ORIENTATION: 'creative_orientation',
    CREATIVE_VIDEO_DURATION_RANGE: 'creative_video_duration_range',
    COUNTRY: 'country_field',
    OS: 'os',
    CAMPAIGN_NAME: 'unified_campaign_name',
    DATE: 'date_field'
};

export const BREAKDOWN_DIMENSIONS = {
    COUNTRY: { value: Dimensions.COUNTRY, label: 'Country' },
    OS: { value: Dimensions.OS, label: 'OS' },
    CAMPAIGN_NAME: { value: Dimensions.CAMPAIGN_NAME, label: 'Campaign' },
    DATE: { value: Dimensions.DATE, label: 'Date' },
};

export const DIMENSION_OPTIONS = [
    BREAKDOWN_DIMENSIONS.COUNTRY,
    BREAKDOWN_DIMENSIONS.CAMPAIGN_NAME,
    BREAKDOWN_DIMENSIONS.OS,
];
